import { PlotFacingTypeEnum, PlotOwnerTypeEnum, PlotTypeEnum, PropertyAvailabilityStatusEnum } from 'pages/PropertyListing/types';
import { PlotForSaleState, StatusFilterEnum } from '.';
import { PlotSizeUnitTypeEnum } from 'pages/ServiceOrder/types';

export const initialState: PlotForSaleState = {
  List: [],
  form: {
    _id: '',
    address: '',
    assetNo: '',
    plotNo: '',
    location: {
      lat: 0,
      lng: 0,
      type: 'Point',
      coordinates: []
    },
    pricePerSqft: '',
    plotSize: '',
    plotType: PlotTypeEnum.Null,
    ventureName: '',
    builderName: '',
    approvalStatus: 2,
    createdAt: '',
    updatedAt: '',
    plotSizeUnit: PlotSizeUnitTypeEnum.Null,
    plotWidth: '',
    plotLength: '',
    additionalInfo: '',
    isActive: false,
    approvals: [],
    availabilityStatus: PropertyAvailabilityStatusEnum.NULL,
    images: [],
    name: '',
    plotFacing: PlotFacingTypeEnum.NULL,
    locationHighlights:"",
    plotSeller: PlotOwnerTypeEnum.DEALER
  },
  loading: false,
  buttonLoading: false,
  search: '',
  pageNo: 1,
  pageSize: 10,
  totalRow: 0,
  orderBy: '',
  orderDir: '',
  status: StatusFilterEnum.OPEN,
  endDate: '',
  startDate: ''
};
